import React, {useEffect, useState} from 'react';
import styled from "styled-components";
import WrapComponent from "./piece/wrapCompoent";
import {itemAPI2} from "../../../../libs/api2";
import OsListComponent from "./osListComponent";
import LayerCaution from "./layerCaution/layerCaution";
import {Button} from "../elementPiece/button";

const OsBuyComponent=({itemId, action, setServiceAddFn})=>{
    const [serviceInfo, setServiceInfo]=useState([])
    const [isLoading, setIsLoading]=useState(false)

    useEffect(() => {
        serviceInfoFn()
    }, []);

    const serviceInfoFn=()=>{
        itemAPI2.getServiceInfo(itemId).then((res)=>{
            if(res){
                const data = res.data.data
                setServiceInfo([data.home[0], data.pro[0]])
            }
            setTimeout(()=>{
                setIsLoading(true)
            },150)
        })
    }

    const addEstimateItem=(itemId)=>{
        setServiceAddFn(itemId,1,action)
    }

    return (
        <>
            <WrapComponent>
                {!isLoading
                    ? (
                        <Loading cdnimg={process.env.REACT_APP_CDN_IMG}/>
                    ) : (
                        <LayerPop>
                            <div className="layer-pop_osbuy_head">
                                <h4 className="tit-h4">
                                    행복쇼핑은 <span>정품 운영체제 구매를 권장</span>합니다.
                                </h4>
                            </div>

                            <div className="os-buy-body">
                                <div className="os-buy-body-box">
                                    <ul className="os-buy-body-box-ul">
                                        {serviceInfo.length > 0 && serviceInfo.map((v,i) => {
                                                const osType = i === 0 ? 'home' : 'pro';
                                                return(
                                                    <OsListComponent key={i} data={v} osType={osType} addEstimateItem={addEstimateItem}/>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>

                                <CautionUl>
                                    {/*조립서비스 종류에 따라 달라지는 레이어 팝업의 주의사항 텍스트*/}
                                    <LayerCaution itemNumber={`${itemId}`}/>
                                </CautionUl>

                                <OtherOs className="button-group ctr">
                                    <a
                                        href={`${process.env.REACT_APP_PC_URL}/list/1030200000${window.location.search}`}
                                        className="other-os otherItem"
                                    >
                                        다른 운영체제를 원하면 클릭하세요.
                                    </a>
                                    <a
                                        href={`${process.env.REACT_APP_PC_URL}/list/1030600000${window.location.search}`}
                                        className="other-office otherItem"
                                    >
                                        오피스 프로그램이 필요하면 클릭하세요.
                                    </a>
                                </OtherOs>
                            </div>

                            <Button
                                type={`close`}
                                className={`icon-close btn-layer-pop_clse`}
                                onClick={action}
                            >
                                <span className="ir">닫기</span>
                            </Button>
                        </LayerPop>
                    )
                }
            </WrapComponent>
        </>
    )
}
export default OsBuyComponent

const Loading = styled.div`
    display: flex;
    width: 950px;
    height: 138px;
    align-items: center;
    justify-content: center;
    background: ${(props) =>
    `transparent url(${props.cdnimg}/img_static/img_pres/_v5/happy_loading_5.gif) no-repeat center`};
    background-size: 60px 69px;

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`

const LayerPop = styled.div`
    font-family: 'Noto Sans KR', "나눔고딕", 'Nanum Gothic', "맑은고딕", 'Malgun Gothic', ‘Apple SD Gothic Neo’, "돋움", dotum, "굴림", gulim, sans-serif;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width:758px;
    box-sizing: border-box !important;
    background: #fff;
    padding:50px 30px 20px;
    border:2px solid #444;

    .tit-h4{
        font-size: 32px;
        text-align: center;
        letter-spacing: -3px;
        span{ color: #f34522; }
    }

    .os-buy-body{
        margin-top:30px;
    }
    .os-buy-body-box{
        padding: 30px;
        border: 2px solid #418ded;
        background: #f4f4f4;
        .os-buy-body-box-ul{

            .os-buy-body-box-ul-li-home,
            .os-buy-body-box-ul-li-pro{
                .tit-h5{
                    float: left;
                    height: 29px;
                    padding-left: 35px;
                    font-size: 16px;
                    line-height: 29px;
                    span{
                        font-weight: normal;
                    }
                }
                .home-icon{
                    background: url(//cdnimg.happyshopping.kr/img_static/img_pres/_v3/ico_house.png) no-repeat 0 0;
                }
                .pro-icon{
                    background: url(//cdnimg.happyshopping.kr/img_static/img_pres/_v3/ico_building.png) no-repeat 4px 0;
                }
                .os-product{
                    float: right;
                    .os-product-name{
                        display: block;
                        font-size: 20px;
                        line-height: 29px;
                    }
                    .os-product-est{
                        margin-top: 10px;
                        font-size: 0;
                        text-align: right;
                    }
                }
            }
            li:not(:first-child){
                padding-top:20px;
                margin-top:20px;
                border-top: 1px solid #ccc;
            }
            li:after{
                display: block;
                clear: both;
                height: 0;
                font-size: 0;
                line-height: 0;
                content: '';
            }

        }

        .button-group{
            margin-top: 32px;
            text-align: center;
            button{
                width: calc(50% - 5px);
                font-size: 20px;
                font-weight: bold;

                height: 60px;
                vertical-align: middle;
                -webkit-box-sizing: border-box;
                -moz-box-sizing: border-box;
                box-sizing: border-box;
            }
            .btn_flat{
                border: 0;
                color: #fff;
                background-color: #418ded;
                &:hover{
                    background: #3281ed;
                }
            }
            .btn_border{
                margin-left: 10px;
                border: 2px solid #418ded;
                color: #418ded;
                background-color: #fff;
                &:hover{
                    background: #f8f8f8;
                }
            }
        }
    }

    .btn-layer-pop_clse{
        position: absolute;
        top: 10px;
        right: 10px;
        color: #418ded;
    }
`

const CautionUl = styled.ul`
    margin-top: 20px;
    li{
        color: #666;
        line-height: 20px;
        word-break: keep-all;
        word-wrap: break-word;
    }
`

const OtherOs = styled.div`
    margin-top: 23px;
    margin-bottom: 23px;
    text-align: center;
    .otherItem{
        display: inline-block;
        width: calc(50% - 5px);
        font-size: 16px;
        font-weight: bold;

        line-height: 58px;
        color: #fff;
        border: 0;
    }
    .other-os{
        background-color: #f34522;
        cursor: pointer;
        box-sizing: border-box;
    }
    .other-office{
        margin-left: 10px;
        background-color: #333;
        cursor: pointer;
        box-sizing: border-box;
    }
`



// WEBPACK FOOTER //
// ./src/estimate_list/components/estimate/service/serviceAsseblyLayer/osBuyComponent.js